module.exports = __webpack_public_path__ + "img/orbit-banner-mobile-s.75eceadb.png";